import { ca } from '@cian/analytics';
import { TPage, TPageExtra } from '../../types/analytics';

export const trackRequestFormShowError = (page: TPage, extra: TPageExtra) => {
  ca('eventSite', {
    action: 'show_sopr',
    category: 'Fail_newbuilding_kpn_survey',
    label: '/sale/flat/object_type=2/from_developer=1/',
    name: 'oldevent',
    page: {
      ...page,
      extra: {
        ...extra,
      },
    },
  });
};
